import React, { Component } from 'react';
import PropTypes from 'prop-types';


import { StyledInfoWrapper } from './styles/StyledInfoWrapper';


class InfoWrapper extends Component {
  render() {
    const { title, text, icon } = this.props;
    return (
      <StyledInfoWrapper>
        <table className="info-wrapper-table">
          <tbody>
            <tr>
              <td className="info-wrapper-icon">
                {icon ? (
                  <i className={'fa ' + icon} aria-hidden="true"></i>
                ) : ( '' )}
              </td>
              <td>
                <div className="info-wrapper-title">
                  { title }
                </div>
                <div className="info-wrapper-title">
                  { text }
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </StyledInfoWrapper>
    );
  }
}


InfoWrapper.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.string,
};


export default InfoWrapper;



// WEBPACK FOOTER //
// ./src/common/InfoWrapper/InfoWrapper.js